import React from 'react';
import { Col } from 'antd';
import { Input, PasswordInput, Select } from '@bettercomp/ui-components';
import { GrandType, OAuth2Auth } from 'types';

export type OAuth2FormErrors = {
  client_id?: string;
  client_secret?: string;
  refresh_token?: string;
  grant_type?: string;
  url?: string;
}

type OAuth2Props = {
  form: OAuth2Auth,
  onChange: (data: OAuth2Auth) => void,
  disabled?: boolean,
  errors?: OAuth2FormErrors,
}

const grandTypeOptions = [
  { value: GrandType.REFRESH_TOKEN, label: 'Refresh Token' },
]

export const OAuth2Form = ({ form, onChange, disabled, errors }: OAuth2Props) => {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    onChange({
      ...form,
      [name]: value,
    })
  };

  const handleSelectChange = (value: GrandType) => {
    onChange({
      ...form,
      grant_type: value,
    })
  }

  return (
    <>
      <Col xs={12}>
        <Select
          value={form.grant_type}
          label="Grant Type"
          placeholder="Grant Type"
          options={grandTypeOptions}
          onChange={handleSelectChange}
          data-testid="Grant Type_Selector"
          error={errors?.grant_type}
        />
      </Col>
      <Col xs={12} data-dd-privacy="hidden" data-sensitive="true">
        <Input
          value={form.client_id}
          label="Client ID"
          name="client_id"
          onChange={handleInputChange}
          disabled={disabled}
          data-testid="Client ID_Input"
          error={errors?.client_id}
        />
      </Col>
      <Col xs={12} data-dd-privacy="hidden" data-sensitive="true">
        <PasswordInput
          value={form.refresh_token}
          label="Refresh Token"
          name="refresh_token"
          onChange={handleInputChange}
          disabled={disabled}
          data-testid="Refresh Token_Input"
          error={errors?.refresh_token}
        />
      </Col>
      <Col xs={12} data-dd-privacy="hidden" data-sensitive="true">
        <PasswordInput
          value={form.client_secret}
          label="Client Secret"
          name="client_secret"
          onChange={handleInputChange}
          disabled={disabled}
          data-testid="Client Secret_Input"
          error={errors?.client_secret}
        />
      </Col>
      <Col xs={12} data-dd-privacy="hidden" data-sensitive="true">
        <Input
          value={form.url}
          label="Token Endpoint"
          name="url"
          onChange={handleInputChange}
          disabled={disabled}
          data-testid="Authentication URL_Input"
          error={errors?.url}
        />
      </Col>
    </>
  )
}
